import { getCookieLoginDate } from 'common/dateUtils';
import Cookies from 'js-cookie';

export class CookieService {
  cookieName = 'RTVCustomer';

  setRTVCookie = (customerId: number) => {
    const loginDate = getCookieLoginDate();
    Cookies.set(this.cookieName, `lastLogon=${loginDate}&id=${customerId}`, {
      path: '/',
      expires: 60 * 60 * 24 * 180,
      domain: 'rikstv.no',
    });
  };
}
